import React from 'react'
// components
import Grid from '@mui/material/Grid2'
import { ReduxDatePicker, ReduxSlider } from 'components/FormElements/ReduxForm'

// types
interface IIncomingProps {
  canModify: boolean
  label: string
}

const PlannedCompletionDate: React.FC<IIncomingProps> = ({ canModify, label }) => {
  return (
    <>
      <Grid>
        <ReduxDatePicker disabled={!canModify} label={label} name={'completionAt'} />
      </Grid>
      <Grid style={{ paddingRight: '8px' }}>
        <ReduxSlider disabled={!canModify} label={'Percentage Complete'} name={'completionPercentage'} />
      </Grid>
    </>
  )
}

export default PlannedCompletionDate
